import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { APIConstants } from '@shared/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExportedFile } from '@shared-features/models';
import { ReceiverType } from '@shared-features/enums/shared-enums.enum';
import { filterNullEntity } from '@shared/utils';
import { Receiver } from '../models/receiver.model';

@Injectable({
  providedIn: 'root',
})
export class ReceiverAPI {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getAllReceivers(customerId?: number): Observable<Receiver[]> {
    const params = filterNullEntity({
      receiverType: ReceiverType.Customer,
      customerId,
    });
    return this.baseAPI.get(APIConstants.API_GET_ALL_RECEIVERS, { params }).pipe(
      map((res) => {
        return this.mapper.fromJson(Receiver, res.data);
      })
    );
  }

  getReceiverById(receiverId: number): Observable<Receiver> {
    return this.baseAPI.get(APIConstants.API_GET_RECEIVER_BY_ID + receiverId).pipe(
      map((res) => {
        return this.mapper.fromJson(Receiver, res.data);
      })
    );
  }

  getReceiverId(receiverId: number): Observable<Receiver> {
    return this.baseAPI.get(APIConstants.API_GET_RECEIVER_BY_ID + receiverId).pipe(
      map((res) => {
        return this.mapper.fromJson(Receiver, res.data);
      })
    );
  }
  addReceiver(receiver: Receiver, receiverType: ReceiverType, locationIds: number[], customerId?: number): Observable<Receiver> {
    receiver.contactPerson.forEach((contact) => {
      for (let propName in contact) {
        if (contact[propName] === null || contact[propName] === undefined) {
          delete contact[propName];
        }
      }
    });

    const body = {
      name: receiver.name,
      receiverType: receiverType,
      contactPerson: receiver.contactPerson,
      locationIds: locationIds,
    };

    if (receiverType === ReceiverType.Customer) body['customerId'] = customerId;

    return this.baseAPI.post(APIConstants.API_ADD_RECEIVER, body).pipe(
      map((res) => {
        return this.mapper.fromJson(Receiver, res.data);
      })
    );
  }

  updateReceiver(receiver: Receiver, locationIds: number[]): Observable<Receiver> {
    const body = {
      id: receiver.id,
      // receiverType: ReceiverType.Customer
    };

    if (receiver.name) body['name'] = receiver.name;

    if (receiver.contactPerson.length) {
      receiver.contactPerson.forEach((contact) => {
        for (let propName in contact) {
          if (contact[propName] === null || contact[propName] === undefined) {
            delete contact[propName];
          }
        }
      });

      body['contactPerson'] = receiver.contactPerson;
    }

    if (locationIds.length) body['locationIds'] = locationIds;

    return this.baseAPI.put(APIConstants.API_UPDATE_RECEIVER, body).pipe(
      map((res) => {
        return this.mapper.fromJson(Receiver, res.data);
      })
    );
  }

  exportRecivers(customerId: number): Observable<ExportedFile> {
    const params = filterNullEntity({
      receiverType: ReceiverType.Customer,
      customerId,
    });
    return this.baseAPI.post(APIConstants.API_EXPORT_RECEIVERS, null, { params }).pipe(
      map((res) => {
        return this.mapper.fromJson(ExportedFile, res.data);
      })
    );
  }
}
